var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70711 8.29289C9.31658 7.90237 8.68342 7.90237 8.29289 8.29289C7.90237 8.68342 7.90237 9.31658 8.29289 9.70711L9.70711 8.29289ZM12.2929 13.7071C12.6834 14.0976 13.3166 14.0976 13.7071 13.7071C14.0976 13.3166 14.0976 12.6834 13.7071 12.2929L12.2929 13.7071ZM5.66667 9.33333C3.64162 9.33333 2 7.69171 2 5.66667H0C0 8.79628 2.53705 11.3333 5.66667 11.3333V9.33333ZM2 5.66667C2 3.64162 3.64162 2 5.66667 2V0C2.53705 0 0 2.53705 0 5.66667H2ZM5.66667 2C7.69171 2 9.33333 3.64162 9.33333 5.66667H11.3333C11.3333 2.53705 8.79628 0 5.66667 0V2ZM9.33333 5.66667C9.33333 7.69171 7.69171 9.33333 5.66667 9.33333V11.3333C8.79628 11.3333 11.3333 8.79628 11.3333 5.66667H9.33333ZM8.29289 9.70711L12.2929 13.7071L13.7071 12.2929L9.70711 8.29289L8.29289 9.70711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.2f86c1971dc28bb8ba98a34c7ace39c4.svg";
export { ForwardRef as ReactComponent };